'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

require('node-forge/lib/x509');

var forge = require('node-forge/lib/forge');

var pki = forge.pki;
exports = module.exports;
/**
 * Gets a self-signed X.509 certificate for the key.
 *
 * The output Buffer contains the PKCS #7 message in DER.
 *
 * TODO: move to libp2p-crypto package
 *
 * @param {KeyInfo} key - The id and name of the key
 * @param {RsaPrivateKey} privateKey - The naked key
 * @returns {undefined}
 */

exports.certificateForKey = function (key, privateKey) {
  var publicKey = pki.setRsaPublicKey(privateKey.n, privateKey.e);
  var cert = pki.createCertificate();
  cert.publicKey = publicKey;
  cert.serialNumber = '01';
  cert.validity.notBefore = new Date();
  cert.validity.notAfter = new Date();
  cert.validity.notAfter.setFullYear(cert.validity.notBefore.getFullYear() + 10);
  var attrs = [{
    name: 'organizationName',
    value: 'ipfs'
  }, {
    shortName: 'OU',
    value: 'keystore'
  }, {
    name: 'commonName',
    value: key.id
  }];
  cert.setSubject(attrs);
  cert.setIssuer(attrs);
  cert.setExtensions([{
    name: 'basicConstraints',
    cA: true
  }, {
    name: 'keyUsage',
    keyCertSign: true,
    digitalSignature: true,
    nonRepudiation: true,
    keyEncipherment: true,
    dataEncipherment: true
  }, {
    name: 'extKeyUsage',
    serverAuth: true,
    clientAuth: true,
    codeSigning: true,
    emailProtection: true,
    timeStamping: true
  }, {
    name: 'nsCertType',
    client: true,
    server: true,
    email: true,
    objsign: true,
    sslCA: true,
    emailCA: true,
    objCA: true
  }]); // self-sign certificate

  cert.sign(privateKey);
  return cert;
};
/**
 * Finds the first item in a collection that is matched in the
 * `asyncCompare` function.
 *
 * `asyncCompare` is an async function that must
 * resolve to either `true` or `false`.
 *
 * @param {Array} array
 * @param {function(*)} asyncCompare An async function that returns a boolean
 */


function findAsync(_x, _x2) {
  return _findAsync.apply(this, arguments);
}

function _findAsync() {
  _findAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(array, asyncCompare) {
    var promises, results, index;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            promises = array.map(asyncCompare);
            _context.next = 3;
            return Promise.all(promises);

          case 3:
            results = _context.sent;
            index = results.findIndex(function (result) {
              return result;
            });
            return _context.abrupt("return", array[index]);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _findAsync.apply(this, arguments);
}

module.exports.findAsync = findAsync;